import React, {useEffect, useState} from 'react';
import TopLight from "./toplight";
import useWindowWidth from "../../../lib/useWindowWidth";
import {useFormContext} from "react-hook-form";
import {useAppContext} from "../../../context/AppContext";
import {basePath, nonStandardColors, standardColors, oxideColors} from "../../../lib/constant";
import {getImageCode} from "../../../lib/colorUtils";


const createRects =  (variation, fillColour = "#CCC5BE") => {
    switch (variation) {
        case 'a' :
            return <>
                <rect x="-200" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="-170" y="200" width="1670" height="30" fill={fillColour}></rect>
                <rect x="1500" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="-200" y="200" width="30" height="30" fill={fillColour}></rect>
                <rect x="1500" y="200" width="30" height="30" fill={fillColour}></rect>
            </>
        case 'b' :
            return <>
                <rect x="-200" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="-170" y="200" width="1370" height="30" fill={fillColour}></rect>
                <rect x="1200" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="-200" y="200" width="30" height="30" fill={fillColour}></rect>
                <rect x="1200" y="200" width="30" height="30" fill={fillColour}></rect>
            </>
        case 'c' :
            return <>
                <rect x="120" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="140" y="200" width="1370" height="30" fill={fillColour}></rect>
                <rect x="1500" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="120" y="200" width="30" height="30" fill={fillColour}></rect>
                <rect x="1500" y="200" width="30" height="30" fill={fillColour}></rect>
            </>
        case 'd' :
            return <>
                <rect x="-200" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="-170" y="-105" width="1670" height="30" fill={fillColour}></rect>
                <rect x="1500" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="-200" y="-105" width="30" height="30" fill={fillColour}></rect>
                <rect x="1500" y="-105" width="30" height="30" fill={fillColour}></rect>
            </>
        case 'e' :
            return <>
                <rect x="-200" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="-170" y="-105" width="1370" height="30" fill={fillColour}></rect>
                <rect x="1200" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="-200" y="-105" width="30" height="30" fill={fillColour}></rect>
                <rect x="1200" y="-105" width="30" height="30" fill={fillColour}></rect>
            </>
        case 'f' :
            return <>
                <rect x="120" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="140" y="-105" width="1370" height="30" fill={fillColour}></rect>
                <rect x="1500" y="-75" width="30" height="2235" fill={fillColour}></rect>
                <rect x="120" y="-105" width="30" height="30" fill={fillColour}></rect>
                <rect x="1500" y="-105" width="30" height="30" fill={fillColour}></rect>
            </>

        default:
            return <>
                <rect x="120" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="140" y="200" width="1070" height="30" fill={fillColour}></rect>
                <rect x="1200" y="230" width="30" height="1930" fill={fillColour}></rect>
                <rect x="120" y="200" width="30" height="30" fill={fillColour}></rect>
                <rect x="1200" y="200" width="30" height="30" fill={fillColour}></rect>
            </>
    }
}

function ConfiguredDoor({translate, viewOverride}) {
    const {watch, getValues} = useFormContext();

    const windowWidth = useWindowWidth();
    const svgViewportWidth =  windowWidth * (3800 / 1425); // Calculate the new SVG width
    const [sidelightColour, setSidelightColour] = useState('')
    const [door_handle_length, setDoor_handle_length] = useState({
        y:'9%',
        height:'65%'
    })


    const [door_colour, setDoor_colour] = useState("");

    const [selectedColourType, setSelectedColourType] = useState("standard");

    const {state} = useAppContext();

    const {view: contextView, selectedInternalColourType, selectedExternalColourType} =
        state;

    const view = viewOverride ?? contextView;

    useEffect(() => {
        if (view === "internal") {
            setSelectedColourType(selectedInternalColourType);
        } else if (view === "external") {
            setSelectedColourType(selectedExternalColourType);
        }
    }, [selectedExternalColourType, selectedInternalColourType,view]);

    // Watch the internal and old external door colours
    const external_door_style = watch("external_door_style");
    const internal_door_colour = watch("internal_door_colour");
    const internal_slab_colour = watch("internal_slab_colour");
    const external_door_colour = watch("external_door_colour");
    const panel = watch("panel");
    const glass_options = watch("glass_option");
    const internal_handle_style = watch("internal_handle_style");
    const external_handle_style = watch("external_handle_style");
    const configuration = watch("configuration");
    const e_key_entry = watch("e_key_entry");
    const opening_direction = watch("opening_direction");
    const external_handle_length = watch("external_handle_length");
    const escutcheon = watch("escutcheon");
    const oxide_frame_colour = watch("oxide_frame_colour");
    const external_door_colour_type = watch("external_door_colour_type");
    const external_slab_colour_type = watch("external_slab_colour_type");
    const internal_slab_colour_type = watch("internal_slab_colour_type");




    useEffect(() => {
        const setColour = (coloursArr) => {
            const foundItem = coloursArr.find(item => item?.code === external_door_colour);
            if (foundItem) {
                setSidelightColour(foundItem.bg);
            }
        };

        switch (selectedExternalColourType) {
            case "standard":
                setColour(standardColors);
                break;
            case "nonstandard":
                setColour(nonStandardColors);
                break;
            default:
                setSidelightColour('#FAFAFA')
                break;
        }
    }, [external_door_colour, selectedExternalColourType]);

    const handle_path =
        external_handle_style === "Round inline"
            ? "round-old external"
            : "square-old external";

    // Update door_colour based on the selectedColourType
    useEffect(() => {
        if (view === "internal") {
            // Use internal slab colour if available, otherwise fall back to internal door colour
            setDoor_colour(internal_slab_colour || internal_door_colour);
        } else if (view === "external") {
            setDoor_colour(external_door_colour);
        }
        console.log(external_door_colour_type);


    }, [internal_door_colour, internal_slab_colour, external_door_colour, view]);

    // Determine the correct colour type and colour for the door body image
    let current_type, current_colour;

    if (view === 'internal') {
        // For internal view: if slab colour exists, use slab colour type; otherwise use frame colour type
        if (internal_slab_colour) {
            current_type = internal_slab_colour_type || 'standard';
            current_colour = internal_slab_colour;
        } else {
            current_type = selectedColourType;
            current_colour = internal_door_colour;
        }
    } else {
        // For external view: always use slab colour type and slab colour for door body
        current_type = external_slab_colour_type || 'standard';
        current_colour = panel || external_door_colour || 'ral_7016';
    }

    const doorImageHref = `${basePath}/${(external_door_style || 'sumatra').toLowerCase()}/${current_type}/${view}/${getImageCode(current_colour)}.png`;


    const house_number = watch("house_number");
    const house_number_material = watch("house_number_style");

    const house_number_colour =
        house_number_material === "stainless steel"
            ? "#e3e3e3"
            : house_number_material === "steel black"
                ? "#141414"
                : "#d8d8d8";



    useEffect(() => {

        switch (external_handle_length) {
            case "900":
                setDoor_handle_length({
                    y:'24%',
                    height:'40%'
                })
                break;

            case "1000":
                setDoor_handle_length({
                    y:'21%',
                    height:'45%'
                })
                break;

            case "1200":
                setDoor_handle_length({
                    y:'18%',
                    height:'50%'
                })
                break;

            case "1400":
                setDoor_handle_length({
                    y:'15%',
                    height:'55%'
                })
                break;

            case "1600":
                setDoor_handle_length({
                    y:'12%',
                    height:'60%'
                })
                break;

            case "1800":
                setDoor_handle_length({
                    y:'9%',
                    height:'65%'
                })
                break;
        }

    }, [external_handle_length]);

    // Get the frame colour for the SVG rects
    const getFrameColour = () => {
        let frameColourCode;

        if (view === "internal") {
            frameColourCode = internal_door_colour;
        } else {
            frameColourCode = external_door_colour_type === 'oxide' ? oxide_frame_colour : external_door_colour;
        }

        if (!frameColourCode) {
            return "#CCC5BE"; // Default fallback
        }

        // Search through all color arrays to find the matching color
        const allColors = [...standardColors, ...nonStandardColors, ...oxideColors];
        const foundColor = allColors.find(color => color.code === frameColourCode);

        return foundColor?.bg || "#CCC5BE"; // Return bg color or fallback
    };

    const frameColour = getFrameColour();




    return (
        <>
            <g transform={translate} opacity="0.7">

                {(glass_options && configuration === 'a') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="-150"
                        y="220"
                        width="1650"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'b') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="-150"
                        y="220"
                        width="1300"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'c') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="200"
                        y="220"
                        width="1300"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'd') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="-150"
                        y="220"
                        width="1650"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'e') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="-150"
                        y="220"
                        width="1300"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'f') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="200"
                        y="220"
                        width="1300"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {(glass_options && configuration === 'none') && (
                    <image
                        xlinkHref={`assets/glass/${glass_options}.svg`}
                        x="200"
                        y="220"
                        width="950"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}
                {createRects(configuration, frameColour)}
                <image
                    href={doorImageHref}
                    x="150"
                    y="220"
                    width="1050"
                    height={2100 - 200}
                    preserveAspectRatio="none"
                />

                {view === "external" && (
                    <image
                        href={`/assets/external-frames/sm/${getImageCode(external_door_colour_type === 'oxide' ? oxide_frame_colour : external_door_colour)}.png`}
                        x="150"
                        y="220"
                        width="1050"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}

                {view === "internal" && (
                    <image
                        href={`/assets/internal-frames/sm/${getImageCode(internal_door_colour || 'ral_7016')}.png`}
                        x="150"
                        y="220"
                        width="1050"
                        height={2100 - 200}
                        preserveAspectRatio="none"
                    />
                )}


                {['a', 'b', 'd', 'e'].includes(configuration) &&
                    // <SideLightLeft sidelightColour={sidelightColour} />
                    <image
                        href={`/assets/frames/${getImageCode(
                            view === "internal"
                                ? internal_door_colour
                                : (external_door_colour_type === 'oxide' ? oxide_frame_colour : external_door_colour)
                        )}.png`}
                        x="-180"
                        y="220"
                        width={330}
                        height={1900}
                        preserveAspectRatio="none"
                    />
                }
                {['a', 'c', 'f', 'd'].includes(configuration) &&
                    // <SideLightRight sidelightColour={sidelightColour}/>
                    <image
                        href={`/assets/frames/${getImageCode(
                            view === "internal"
                                ? internal_door_colour
                                : (external_door_colour_type === 'oxide' ? oxide_frame_colour : external_door_colour)
                        )}.png`}
                        x="1200"
                        y="220"
                        width={310}
                        height={1900}
                        preserveAspectRatio="none"
                    />
                }
                {['d', 'e', 'f'].includes(configuration) &&
                    <TopLight sidelightColour={sidelightColour} configuration={configuration}/>
                }
                {(view === "external" && house_number_material !== 'none') && (
                    <text
                        className='bg-red-500'
                        fontSize={70}
                        x={['a', 'c', 'd', 'f'].includes(configuration) ? 1600 : 1300}
                        y={500}
                        fill={house_number_colour}
                        style={{ textAnchor: 'start' }}
                    >
                        {house_number}
                    </text>
                )}
                {view === "internal" && (
                    <image
                        href={`assets/handles/internal/${opening_direction}/${internal_handle_style}.png`}
                        x={`${opening_direction === 'Hung on left' ? '160' : '950'}`}
                        y="38%"
                        width="250"
                        height="250"
                        preserveAspectRatio="none"
                    />
                )}
                {view === "external" && (
                    <image
                        href={`assets/handles/scene external/${external_handle_style}.png`}
                        x={`${opening_direction === 'Hung on right' ? '250' : '950'}`}
                        {...door_handle_length}
                        width="150"
                        preserveAspectRatio="none"
                    />
                )}
                {e_key_entry && view === "external" && e_key_entry !== 'none' &&
                    <image
                        href={`/assets/e_key/${e_key_entry}.png`}
                        x={
                            e_key_entry === 'Integra'
                                ? (opening_direction === 'Hung on right' ? '180' : '990')
                                : (opening_direction === 'Hung on right'
                                    ? (configuration === 'a' || configuration === 'b' ? '-450' : '-200')
                                    : (configuration === 'a' || configuration === 'c' ? '1500' : '1250'))
                        }
                        y="1100"
                        width={e_key_entry === 'Integra' ? '180' : '200'}
                        height={e_key_entry === 'Integra' ? '180' : '200'}
                        preserveAspectRatio="none"
                    />
                }
                {escutcheon && view === "external" &&
                    <image
                        href={`/assets/escutcheon/scene/${escutcheon.replace(/ /g, "-")}.png`}
                        x={opening_direction === 'Hung on right' ? '215' : '1030'}
                        y="1280"
                        width='100'
                        height='100'
                        preserveAspectRatio="none"
                    />
                }
            </g>
        </>
    );
}

export default ConfiguredDoor;
